import React from "react"
import ProductTiles from "@airasia/phoenix-widgets/widgets/ProductTiles"

import { GTM_PROJECT_CATEGORY } from "../../utils/constants"
import { fireGtmEvent } from "../../utils/functions"
import CATEGORY_TILE_DATA from "../../data/phoenix/foodCategories"

const CategoryTileFilter = props => {
  var {
    categoryIds,
    countryUrl,
    onTileClick,
    device,
    highlightTileByDefaultId,
  } = props

  let selectedCategory = "All"
  categoryIds = categoryIds || []
  categoryIds.sort();
  const productTileDetails = []

  var language = countryUrl==="/th/th/"? "TH_TH":"EN"
  if (countryUrl==="/id/id/")
    language="ID"
  if (countryUrl==="/th/")
    language="TH"
  const updateCategory = food => {
    selectedCategory = food

    return selectedCategory
  }

  for (let categoryId of categoryIds) {
    if (CATEGORY_TILE_DATA[language][categoryId]) {
      productTileDetails.push(CATEGORY_TILE_DATA[language][categoryId])
    }
  }

  return (
    productTileDetails.length && (
      <ProductTiles
        configObj={{
          enableGtm: "TRUE",
          gtmParameters: {
            event: "trackEventNoEcommerce",
            eventActionClick: "click",
            eventActionView: "view",
            eventCategory: `${GTM_PROJECT_CATEGORY}|categorytitles`,
            eventLabelCardClick: " {{productid}}|{{producttilesposition}} ",
            eventLabelHeadlineClick: "",
            eventLabelView: `{{tilesname}}|{{tilesorder}}`,
          },
          productTileDetails: productTileDetails,
          showAll: {
            categoryTextMobile: "All categories",
            categoryTextWeb: "All categories",
            icon:
              "https://storage.googleapis.com/airasia-repository-prod/images/misc/product-tiles/showall_flat.svg",
            label: countryUrl==="/th/th/"?"ทั้งหมด":"Show All",
            productID: "showall",
          },
        }}
        widgetFunction={(click, productId) => {
          onTileClick(click, productId)
          updateCategory(productId)
        }}
        dynamicOrdering
        highlightTileByDeFaultId={highlightTileByDefaultId}
        device={device}
        customProperties={{
          id: "foodCategoryTileFilter",
        }}
        fireGtm={obj => {
          fireGtmEvent(obj)
        }}
      />
    )
  )
}

CategoryTileFilter.defaultProps = {
  device: "desktop",
}

export default CategoryTileFilter
